import ControlFactory from '@/Factories/ControlFactory';
import AssociationCheckBoxViewModel from '@/ViewModels/Controls/AssociationCheckBoxViewModel';
import AssociationCheckBox from '@/Controls/AssociationCheckBox';
import AssociationCheckBoxViewModelT from '@/ViewModels/Controls/AssociationCheckBoxViewModel';
import CheckBoxViewModelT from '@/ViewModels/Controls/CheckBoxViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import RADApplication from '@/Management/RADApplication';
import ComponentManager from '@/Management/ComponentManager';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import Loader from '@/Utility/Loader';
import FilterHelper from '@/Utility/FilterHelper';
import LocatorHelper from '@/Utility/LocatorHelper';
export default class AssociationCheckBoxFactory extends ControlFactory {
    /** Overrides */
    public control: AssociationCheckBox;
    /** Overrides */
    public viewModel: AssociationCheckBoxViewModel;
    public defaultIterator: any;
    public dataIterator: any;
    public iterator: any;
    public labelPosition: any;
    private dataBusy: any;
    private valueBusy: any;
    private AssociationCheckBoxViewModel: any;
    private AssociationCheckBox: any;
    private ObjectDisconnectionHelper: any;
    private CheckBoxViewModel: any;
    protected LabelViewModel: any;
    private jQueryControl: JQuery;
    protected _objectHelper: any;
    constructor(params: any) {
        super(params);
        this.jQueryControl = null;
        this.dataBusy = this.observableOrDefault(false);
        this.valueBusy = this.observableOrDefault(false);
        let setBusy = () => {
            let isBusy = this.dataBusy() || this.valueBusy();
            this.isBusy(isBusy);
        };
        this.defineSubscription(this.dataBusy, setBusy);
        this.defineSubscription(this.valueBusy, setBusy);
        this.defaultIterator = this.context.defaultIterators[this.detailViewItem.name];
        this.dataIterator = null;
        this.iterator = null;
        this.AssociationCheckBoxViewModel = ComponentManager.getViewModel<typeof AssociationCheckBoxViewModelT>('AssociationCheckBoxViewModel');
        this.AssociationCheckBox = ComponentManager.getControl('AssociationCheckBox');
        this.ObjectDisconnectionHelper = ComponentManager.getUtility('ObjectDisconnectionHelper');
        this.CheckBoxViewModel = ComponentManager.getViewModel<typeof CheckBoxViewModelT>('CheckBoxViewModel');
        this.LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
        this.registerForMessageId('RefreshAssociationsMessage', () => {
            this.viewModel.data.evaluate();
            this.viewModel.values.evaluate();
        });
    }
    /** Overrides */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        this.labelPosition = this.paramOrDefault('Top');
        this.viewModel = (() => {
            let getIterator = () => {
                return RADEnvironmentProxy.getInstance().createIteratorForAssoziation({
                    pdTypeName: this.context.genericObject.pdTypeName,
                    pdo_id: this.context.genericObject.pdoId,
                    assoziationName: this.detailViewItem.name,
                    properties: ['ObjectIdentValue'],
                    retrieveExtentCount: true,
                    itOperator: {
                        includeAllPrincipals: this.detailViewItem.listView.includeAllPrincipals,
                        includeBasePrincipals: this.detailViewItem.listView.includeBasePrincipals,
                        includeSubPrincipals: this.detailViewItem.listView.includeSubPrincipals,
                        memoryOptimizationEnabled: true,
                        onlySubPrincipals: null,
                        historizationDates: null,
                        isGridIterator: null,
                        principalFilter: null,
                        searchObjectPositionRequest: null,
                        visibleDeletedObjects: null,
                        hideConnectedElementsRequest: null
                    },
                    filter: '',
                    orderby: ''
                });
            }


            let onIteratorLoaded = (iterator) => {
                this.iterator = iterator;
                if (this.iterator.extentCount > 0) {
                    return RADEnvironmentProxy.getInstance().getExtentWithPDOIDAsFirstColumn({
                        iteratorID: this.iterator.id,
                        start: 0,
                        end: this.iterator.extentCount - 1
                    }).then((arrayOfGeneric) => {
                        let result = [];
                        for (let i = 0; i < arrayOfGeneric.length; i++) {
                            result.push(arrayOfGeneric[i][0]);
                        }
                        return result;
                    });
                } else
                    return $.Deferred().resolve([]);
            }

            return new this.AssociationCheckBoxViewModel({
                factory: this,
                isRequired: this.isRequired,
                invalidationText: this.invalidationText,
                isValid: this.isValid,
                isBusy: this.isBusy,
                parentLocator: this.locator,
                tooltip: new this.LabelViewModel({
                    ergName: this.detailViewItem.tooltip
                }),
                locator: this.detailViewItem.name,
                data: this.defineAsyncComputed((): any => {
                    this.dataBusy(true);
                    this.deleteIterators([this.dataIterator]);
                    let ret = RADEnvironmentProxy.getInstance().createIteratorWithOperator({
                        pdTypeName: this.detailViewItem.listView.typeName,
                        properties: ['ObjectIdentValue'],
                        filter: JSON.stringify(
                            FilterHelper.createFilterObjectForStaticFilter(this.detailViewItem.listView
                                .staticFilterExpression)),
                        orderby: this.detailViewItem.listView.defaultOrder,
                        retrieveExtentCount: true,
                        contextPDO_ID: this.isSummaryViewMode ? "" + -1 : this.context.genericObject.pdoId,
                        itOperator: {
                            includeAllPrincipals: this.detailViewItem.listView.includeAllPrincipals,
                            includeBasePrincipals: this.detailViewItem.listView.includeBasePrincipals,
                            includeSubPrincipals: this.detailViewItem.listView.includeSubPrincipals,
                            memoryOptimizationEnabled: true,
                            onlySubPrincipals: null,
                            historizationDates: null,
                            isGridIterator: null,
                            principalFilter: null,
                            searchObjectPositionRequest: null,
                            visibleDeletedObjects: null,
                            hideConnectedElementsRequest: null
                        }
                    }).then((iterator) => {
                        this.dataIterator = iterator;
                        if (this.isDisposed === false && +iterator.extentCount > 0) {
                            return RADEnvironmentProxy.getInstance().getExtentWithPDOIDAsFirstColumn({
                                iteratorID: iterator.id,
                                start: 0,
                                end: +iterator.extentCount - 1
                            });
                        } else
                            return null;
                    }).then((arrayOfGeneric) => {
                        if (arrayOfGeneric && this.isDisposed === false) {
                            let result = [];
                            for (let i = 0; i < arrayOfGeneric.length; i++) {
                                (() => {
                                    let thisCheckBox = new this.CheckBoxViewModel({
                                        value: arrayOfGeneric[i][0],
                                        parentLocator: this.locator,
                                        isFocusable: this.isFocusable,
                                        locator: LocatorHelper.buildLocator(this.detailViewItem.name, i),
                                        onClick: (isChecked, value) => {
                                            this.evaluate(this.viewModel.onChange(isChecked, value)).then(
                                                (result) => {
                                                    if (!result) {
                                                        thisCheckBox.revert();
                                                    }
                                                });
                                        },
                                        label: new this.LabelViewModel({
                                            caption: arrayOfGeneric[i][1],
                                            parentLocator: this.locator,
                                            locator: LocatorHelper.buildLocator(this.detailViewItem.name, i, 'label')
                                        }),
                                        isEnabled: this.isEnabled
                                    });
                                    result.push(thisCheckBox);
                                })();
                            }
                            return result;
                        }
                        return null;
                    });
                    ret.always(() => {
                        if (this.isDisposed)
                            return;

                        this.dataBusy(false);
                    });
                    return ret;
                }, []),
                values: this.defineAsyncComputed((): any => {
                    this.valueBusy(true);
                    this.deleteIterators([this.iterator]);
                    let ret = $.when(getIterator()).then((iterator) => {
                        let end = onIteratorLoaded(iterator);
                        end.always(() => {
                            if (this.isDisposed)
                                return;

                            this.valueBusy(false);
                        });
                        return end;
                    });
                    return ret;
                }, []),
                onConnect: (toPDOID) => {
                    return this.OnConnection(toPDOID);
                },
                onDisconnect: (toPDOID) => {
                    let dfd = $.Deferred();
                    let disconnectionHelper = new this.ObjectDisconnectionHelper({
                        contextPdoId: this.context.genericObject.pdoId,
                        associationName: this.detailViewItem.listView.relationName,
                        pdTypeName: this.detailViewItem.listView.typeName,
                        affectedObjectIds: [toPDOID],
                        disconnectionCallback: () => {
                            this.OnDisconnectionCallback(toPDOID).then((result) => {
                                dfd.resolve(result);
                            });
                        },
                        confirmDeletionCallback: (dialogResult) => {
                            this.OnConfirmDeletionCallback(dialogResult, toPDOID).then((result) => {
                                dfd.resolve(result);
                            });
                        }
                    });
                    disconnectionHelper.ExecuteCheck();
                    return dfd.promise();
                }
            });
        })();
        this.control = (() => {
            return new this.AssociationCheckBox(this.viewModel);
        })();
        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;
        this.registerObservableValidation(this.viewModel.values);
        return this.jQueryControl;
    }
    public notifyDetailViewClosed(topdTypeName?: any, toPDOID?: any): void {
        let associationName = this.detailViewItem.listView.relationName;
        this.viewModel.data.evaluate();
        this.viewModel.values.evaluate();
        this.context.genericObject.isModified(true);
        this.context.notifyUpdatedAssociation(associationName);
        this.context.notifyFactoryRefreshed(this.detailViewItem);
    }
    public deleteIterators(iterators: any): any {
        if (this.isDisposed || iterators == null) {
            return;
        }
        iterators = iterators.filter((it) => { return it != null; });
        if (iterators != null && iterators.length > 0) {
            RADEnvironmentProxy.getInstance().deleteIterators({
                iteratorIDs: iterators.map((it) => { return parseInt(it.id); })
            });
        }
    }
    
    protected disposeInternal(): void {
        this.deleteIterators([this.defaultIterator, this.dataIterator, this.iterator]);
        super.disposeInternal();
    }
    
    private OnConnection(objectIdToConnect: any): any {
        return $.when(this.context.notifyBeforeUpdatedAssociation(this.detailViewItem.listView.relationName, 'connect', { toPdoIds: [objectIdToConnect] }))
            .then((doUpdateAssociation) => {
                if (doUpdateAssociation == null || doUpdateAssociation === true) {
                    Loader.getInstance().show();
                    let contextId = this.context.genericObject.pdoId;
                    if (+contextId > 0) {
                        return RADEnvironmentProxy.getInstance().connect({
                            pdoID: contextId,
                            assoziationName: this.detailViewItem.listView.relationName,
                            topdTypeName: this.detailViewItem.listView.typeName,
                            toPDOID: objectIdToConnect,
                            nestedContextName: this.context.getNestedContextPath()
                        }).then((changeObject) => {
                            if (!this.validateStatus(changeObject))
                                return false;

                            this.context.genericObject.isModified(true);
                            this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                            this.context.notifyFactoryRefreshed(this.detailViewItem);
                            return true;
                        }).always(() => {
                            Loader.getInstance().hide();
                        });
                    } else {
                        return RADEnvironmentProxy.getInstance().getObject({
                            pdTypeName: this.detailViewItem.listView.typeName,
                            pdoID: objectIdToConnect,
                            properties: ['ObjectIdentValue']
                        }).then((genericDTO) => {
                            return true;
                        }).always(() => {
                            Loader.getInstance().hide();
                        });
                    }
                }
                return false;
            });
    }
    private OnDisconnectionCallback(pdoId: any): any {
        return $.when(this.context.notifyBeforeUpdatedAssociation(this.detailViewItem.listView.relationName, 'disconnect', { toPdoIds: [pdoId] }))
            .then((doUpdateAssociation) => {
                if (doUpdateAssociation == null || doUpdateAssociation === true) {
                    Loader.getInstance().show();
                    return RADEnvironmentProxy.getInstance().disconnect({
                        pdoID: this.context.genericObject.pdoId,
                        assoziationName: this.detailViewItem.listView.relationName,
                        topdTypeName: this.detailViewItem.listView.typeName,
                        toPDOID: pdoId,
                        nestedContextName: this.context.getNestedContextPath()
                    }).then((changeObject) => {
                        if (this.isDisposed !== false || !this.validateStatus(changeObject))
                            return false;

                        this.context.genericObject.isModified(true);
                        this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                        this.context.notifyFactoryRefreshed(this.detailViewItem);
                        return true;
                    }).always(() => {
                        Loader.getInstance().hide();
                    });
                }
                return false;
            });
    }
    private OnConfirmDeletionCallback(dialogResult: any, pdoId: any): any {
        if (dialogResult === true) {
            let associationName = this.detailViewItem.listView.relationName;
            return $.when(this.context.notifyBeforeUpdatedAssociation(associationName, 'disconnectAndDelete', { toPdoIds: [pdoId] }))
                .then((doUpdateAssociation) => {
                    if (doUpdateAssociation == null || doUpdateAssociation === true) {
                        Loader.getInstance().show();
                        let pdTypeName = this.detailViewItem.listView.typeName;
                        return RADEnvironmentProxy.getInstance().deleteObject({
                            pdTypeName: pdTypeName,
                            pdoID: pdoId
                        }).then((changeObject) => {
                            if (this.isDisposed !== false || !this.validateStatus(changeObject))
                                return false;

                            this.context.genericObject.isModified(true);
                            this.context.notifyUpdatedAssociation(associationName);
                            this.context.notifyFactoryRefreshed(this.detailViewItem);
                            if (this._objectHelper) {
                                this._objectHelper.ExecuteAction();
                            }
                            return true;
                        }).always(() => {
                            if (!this.isDisposed) {
                                this.viewModel.values.evaluate();
                            }

                            Loader.getInstance().hide();
                        });
                    }
                    return false;
                });
        }
        return Promise.resolve();
    }
}

ComponentManager.setFactory('AssociationCheckBox', AssociationCheckBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('AssoziationCheckBox', AssociationCheckBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');